import React from "react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const EMERGENT_AUTH_URL = "https://auth.emergentagent.com/";

/**
 * "Continue with Google" button — kicks off Emergent-managed OAuth.
 * Optional ``inviteToken`` is preserved through the redirect via sessionStorage
 * so the callback can link the new account to that invite.
 */
export default function GoogleButton({ label = "Continue with Google", inviteToken, companyName, signupPrefill, onBeforeRedirect, testid = "google-signin-button" }) {
  const onClick = () => {
    // Allow the caller to validate (e.g. require a company name) before redirect.
    if (typeof onBeforeRedirect === "function" && onBeforeRedirect() === false) return;
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    if (inviteToken) {
      sessionStorage.setItem("pending_invite_token", inviteToken);
    } else {
      sessionStorage.removeItem("pending_invite_token");
    }
    // Preserve a company name for brand-new self-serve Google signups through the redirect.
    if (companyName && String(companyName).trim()) {
      sessionStorage.setItem("pending_company_name", String(companyName).trim());
    } else {
      sessionStorage.removeItem("pending_company_name");
    }
    // /signup: defer account creation — just resolve identity to pre-fill the form.
    if (signupPrefill) {
      sessionStorage.setItem("pending_signup_prefill", "1");
    } else {
      sessionStorage.removeItem("pending_signup_prefill");
    }
    window.location.href = `${EMERGENT_AUTH_URL}?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className="w-full h-10 inline-flex items-center justify-center gap-2.5 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-800 text-[13.5px] font-semibold transition-colors"
    >
      <svg className="h-[18px] w-[18px]" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09Z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.26 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A10.99 10.99 0 0 0 12 23Z" fill="#34A853"/>
        <path d="M5.84 14.1A6.6 6.6 0 0 1 5.48 12c0-.73.13-1.44.36-2.1V7.06H2.18A11.005 11.005 0 0 0 1 12c0 1.77.42 3.44 1.18 4.94l3.66-2.84Z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.07.56 4.21 1.65l3.16-3.16C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38Z" fill="#EA4335"/>
      </svg>
      {label}
    </button>
  );
}

export function OrDivider() {
  return (
    <div className="flex items-center gap-3 my-1">
      <div className="flex-1 h-px bg-slate-200" />
      <div className="text-[10.5px] uppercase tracking-widest font-semibold text-slate-400">or</div>
      <div className="flex-1 h-px bg-slate-200" />
    </div>
  );
}
